module.exports = __webpack_public_path__ + "static/commencement-57f5db41d3bc4d366d4829a6da2b8bf8.jpg";